import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import Button from './Button.js';
const KnowledgeBase = (props) => {
    return (React.createElement(HelpBox, { style: props.style },
        React.createElement("span", null, props.header),
        React.createElement("p", null, props.body),
        props.button && (React.createElement(Button, { theme: "secondary", href: props.button.href, target: "_blank" }, props.button.label)),
        props.children));
};
export default KnowledgeBase;
const HelpBox = styled.div `
  background-color: #f5f5f5;
  border-left: 3px solid ${THEME.COLOR_ACCENT};
  padding: 15px;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: ${THEME.GRID_SPACING}px;

  & > span {
    font-weight: bold;
    font-size: 16px;
    display: block;
    margin-bottom: 20px;
  }

  & > a {
    text-decoration: underline;
    color: black;
  }
`;
//# sourceMappingURL=KnowledgeBase.js.map